<h1>Confirm your email!</h1>

<p>We've sent a confirmation email to {{ myEmail$ | async}}. Click on the link "Confirm my email" to activate your account.</p>

<button
  mat-stroked-button
  (click)="auth.signOut()"
>Sign out</button>

<button
  mat-stroked-button
  *ngIf="['unsent', 'sending'].includes(resendStatus)"
  [disabled]="resendStatus === 'sending'"
  (click)="resendEmailVerification()"
>{{resendStatus === 'unsent' ? 'Resend confirmation email' : 'Sending...'}}</button>

<p *ngIf="resendStatus === 'error'" class="error">There was an error resending your confirmation email. Wait for a few minutes and try again, or drop us a line at <a href="mailto:support@innersightlabs.com">support&#64;innersightlabs.com</a></p>

<ng-container *ngIf="resendStatus === 'sent'">
  <p>Email verification sent.</p>
  <p>If you are having trouble receiving the email confirmation, drop us a line at <a href="mailto:support@innersightlabs.com">support&#64;innersightlabs.com</a>.</p>
</ng-container>
